import { ComponentProps } from 'react';
import { ArrowDownIcon, ArrowUpIcon, HStack } from 'native-base';

import { Text } from '@pimm/base';
import { calculateVariance, formatVariance } from '../_helper';

type VarianceBadgeProps = ComponentProps<typeof HStack> & {
  actual?: number;
  forecast?: number;
};

export const VarianceBadge = ({ actual = 0, forecast = 0, ...props }: VarianceBadgeProps) => {
  const variance = calculateVariance(actual, forecast);

  if (variance == null || variance === 0) return null;

  const positive = variance >= 0;
  const color = positive ? 'blueLight.700' : 'error.700';

  return (
    <HStack rounded="md" bg={positive ? 'blueLight.100' : 'error.100'} px={0.5} alignItems="center" space={0.5} {...props}>
      {positive ? <ArrowUpIcon size="10px" color={color} /> : <ArrowDownIcon size="10px" color={color} />}
      <Text size="sm" fontWeight={600} color={color}>
        {formatVariance(variance)}
      </Text>
    </HStack>
  );
};
